
import {from as observableFrom,  of ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx/src/data-persistence';
import { map ,  switchMap ,  mapTo } from 'rxjs/operators';

import { toDashedFromCamelCase } from '../../../../../helpers/';
import { GITHUB_COMMIT_PL } from '../../../../constants/';
import { GetCompleteAction, NoopAction, UndoAction } from '../../../../ngrx/actions/root.action';
import { AppState, getEmptyESState } from '../../../../ngrx/state/';
import { jsonApiToEntityState } from '../../../../shared/services/app/web-socket/http-response';
import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import * as githubCommit from './github-commit.actions';
import { Features } from '../../../../libs/paywall/features.constants';
import { PaywallService } from '../../../../libs/paywall/paywall.service';

@Injectable()
export class GithubCommitEffects {
  private key = toDashedFromCamelCase(GITHUB_COMMIT_PL);

  readonly defaultErrorHandler = (action, error) => {
    console.error('effect', action, error);
  };

  @Effect()
  getByTask$ = this._paywall.isFeatureEnabled(Features.Github)
    ? this.data.fetch(githubCommit.GET_TASK_COMMIT, {
        run: (action: githubCommit.GetTaskCommit, store) =>
          this.api.get([this.key], action.payload).pipe(
            map(jsonApiToEntityState),
            switchMap(state => {
              const actions = [
                new GetCompleteAction(state),
                new githubCommit.GetTaskCommitComplete({
                  taskId: action.payload.task,
                  entities: state[GITHUB_COMMIT_PL] || getEmptyESState()
                })
              ];
              return of(...actions);
            })
          ),
        onError: (action, error) => {
          this.defaultErrorHandler(action, error);
          return new githubCommit.GetTaskCommitFail();
        }
      })
    : observableFrom([]);

  @Effect()
  remove$ = this._paywall.isFeatureEnabled(Features.Github)
    ? this.data.optimisticUpdate(githubCommit.DELETE_TASK_COMMIT, {
        run: (action: githubCommit.DeleteTaskCommit, store) =>
          this.api.deleteRequest([this.key, action.payload.id]).pipe(mapTo(new NoopAction())),
        undoAction: (action, error) => {
          this.defaultErrorHandler(action, error);
          return new UndoAction(action);
        }
      })
    : observableFrom([]);

  constructor(
    private api: AtlazApiV2Service,
    private data: DataPersistence<AppState>,
    private _paywall: PaywallService
  ) {}
}
